<div
  [className]="isCollapsable ? 'collapsable-container' : 'collapsable-container no-top-radius'"
  [style.border]="withBorder ? '2px solid #f7f7f7' : 'none'">
  <div *ngIf="title" class="group-header" (click)="handleCollapsableClick()" (keydown.enter)="handleCollapsableClick()">
    <div class="title">{{ title | translate }}</div>
    <div class="pointer" *ngIf="isCollapsable && !searchMode" [ngClass]="isOpen ? 'arrow-open' : 'arrow-closed'">
      <div class="arrow"></div>
    </div>
  </div>
  <div [className]="isOpen ? 'options-wrapper-open' : 'options-wrapper-closed'">
    <div class="content-animation">
      <ng-content></ng-content>
    </div>
  </div>
</div>
